import React from "react";

import { Router } from "@/types";

export const RouterContext = React.createContext<Router | undefined>(undefined);
